import { FC } from 'react'

import { TIconProps } from '.'

export const CircleCheck: FC<TIconProps> = ({ size, color = '#81CB31' }) => {
  return (
    <svg
      style={{
        width: 'auto',
        height: size,
      }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="circle-check-icon"
    >
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.93169 12.9999C8.79369 12.9999 8.66169 12.9429 8.56719 12.8424L6.13569 10.2529C5.94619 10.0519 5.95669 9.73543 6.15769 9.54643C6.35919 9.35743 6.67569 9.36743 6.86419 9.56843L8.92669 11.7639L13.1307 7.16293C13.3177 6.95843 13.6337 6.94493 13.8377 7.13093C14.0412 7.31693 14.0552 7.63343 13.8692 7.83693L9.30069 12.8369C9.20719 12.9399 9.07419 12.9989 8.93519 12.9999H8.93169Z"
        fill="white"
      />
    </svg>
  )
}
